
import * as actionTypes from '../actions/actionTypes';
 
const initialState = {
  error: null,
  loading: false
}

 export const common = (state=initialState, action)=>{
   switch(action.type){
     case actionTypes.API_START:
        return {
          ...state,
          error: null,
          loading: true
        };
     case actionTypes.API_COMPLETE:
       return {
         ...state,
         error: null,
         loading: false
       };
      case actionTypes.API_FAIL:
        return {
          ...state,
          error: action.error,
          loading: false
        }
      default:
        return state;
   }
 }

 export default common;
